import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const ExemptSouthCarolina = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="South Carolina Nonprofit Filing Requirements & Deadlines"
          description="Learn South Carolina’s non-profit filing requirements, deadlines, and compliance rules. Ensure your organization stays in good standing with the state."
          keywords=" "
          canonical="nonprofit-taxes/south-carolina-state-filing-requirements/"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/state-sc-landing-img.webp" />
                <source srcSet="/assets/images/state-sc-landing-img.png" />
                <img
                  src="/assets/images/state-sc-landing-img.png"
                  alt="South Carolina State Filing Requirements"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                <span className="highlight-container">
                  <span className="highlight">South Carolina State </span>
                </span>{' '}
                Filing Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                South Carolina nonprofits must register with the Secretary of
                State, maintain charitable solicitation filings, and meet tax
                exemption rules to stay compliant.
              </Typography>

              {/* <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sourthcarolina`}
                  >
                    Get Started
                  </Button>
                 
                </Box>
              </Stack> */}
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/state-sc-landing-img-sm.webp" />
                <source srcSet="/assets/images/state-sc-landing-img-sm.png" />
                <img
                  src="/assets/images/state-sc-landing-img-sm.png"
                  alt="South Carolina State Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Required Non-profit Forms
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Non-profits in South Carolina are required to complete several forms
            as part of their compliance obligations.
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 5 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Secretary of State Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Public Charities Division (Secretary of State)
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Department of Revenue Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Forms (Required for State Compliance)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 16 }}>
                              Nonprofit Corporation Articles of Incorporation
                              (Form DOMNP)
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              TApplication for Certificate of Authority (Foreign
                              Nonprofit Corporations)
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              Annual Report (if required by IRS Form 990 filing)
                            </li>
                          </ul>
                          <Alert severity="warning" icon={false} sx={{ mt: 2 }}>
                            <b>Note:</b> All the above-mentioned forms must be
                            filed online from{' '}
                            <Link
                              href="https://sos.sc.gov/online-filings/business-entities"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              Online Filings Business Portel
                            </Link>
                          </Alert>
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="https://sos.sc.gov/online-filings/charities-pfrs-and-raffles/charities"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                Initial Charitable Organization Registration
                              </Link>
                            </li>

                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="https://sos.sc.gov/online-filings/charities-pfrs-and-raffles/charities"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                {' '}
                                Charitable Organization Annual Renewal
                              </Link>
                            </li>
                          </ul>
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="https://dor.sc.gov/sales-use-tax-index/sales-tax-exemptions"
                                target="_blank"
                                sx={{ color: '#0202ff' }}
                              >
                                ST-387: Application for Sales and Use Tax
                                Exemption
                              </Link>
                            </li>
                          </ul>
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 16 }}>
                              Form 1023 (Application for Recognition of
                              Exemption Under Section 501(c)(3) of the Internal
                              Revenue Code): For most charitable organizations
                            </li>

                            <li style={{ marginBottom: 16 }}>
                              Form 1024 (Application for Recognition of
                              Exemption Under Section 501(a) or Section 521 of
                              the Internal Revenue Code): For other types of
                              nonprofits.
                            </li>
                            <li style={{ marginBottom: 16 }}>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990/"
                                sx={{ color: '#0202ff' }}
                              >
                                Form 990 (Return of Organization Exempt From
                                Income Tax)
                              </Link>
                              : Annual information return for <br />
                              tax-exempt organizations.
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ pt: 6, pb: 6, textAlign: 'center' }}>
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 5, pb: 2 }}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box
              sx={{
                px: { md: 0, sm: 0, xs: 2 },
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: { md: 'left', xs: 'center' },
              }}
            >
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                State Filing Requirements for Non-Profits
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                South Carolina’s growing nonprofit sector makes it an attractive
                state to establish a charitable organization.
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                To operate legally, you must meet state filing requirements:
              </Typography>
              <Box
                component="ol"
                sx={{ mb: 2, textAlign: 'left', '& li': { mb: 1.5 } }}
              >
                <li>
                  <span style={{ fontWeight: 600 }}>Choose Your Structure</span>{' '}
                  – Most nonprofits are formed as nonprofit corporations.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    Name Your Organization
                  </span>{' '}
                  – Check name availability via the{' '}
                  <Link
                    href="https://businessfilings.sc.gov/BusinessFiling/Entity/Search"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    SC Secretary of State Business Name
                  </Link>{' '}
                  Search.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Appoint a Registered Agent
                  </span>{' '}
                  – Must have a physical address in South Carolina.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    File Formation Documents
                  </span>{' '}
                  – File Articles of Incorporation with the SC Secretary of
                  State ($25 fee).
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Adopt Bylaws & Hold Meetings
                  </span>{' '}
                  – Establish bylaws, elect officers, and record board minutes.
                </li>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box>
              <picture>
                <source srcSet="/assets/images/who-file-sc-img.webp" />
                <source srcSet="/assets/images/who-file-sc-img.png" />
                <img
                  src="/assets/images/who-file-sc-img.png"
                  alt="State Filing Requirements for Non-Profits"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={500}
                  height={500}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Paper
                variant="outlined"
                sx={{ px: 3, py: 5, borderRadius: 5, maxWidth: 900 }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'center',
                      lineHeight: 1.5,
                    }}
                  >
                    Tax Exemption Requirements
                  </Typography>
                  <Typography
                    component="div"
                    variant="body1"
                    sx={{ textAlign: 'center' }}
                  >
                    To gain tax-exempt status, a nonprofit must meet specific
                    requirements set by the IRS.
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      '& li': {
                        // float: 'left',
                        fontSize: 16,
                        display: 'flex',
                      },
                    }}
                  >
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1, mt: -0.1 }}
                      />
                      <Box>
                        Obtain an{' '}
                        <span style={{ fontWeight: 600 }}>
                          IRS Determination Letter
                        </span>{' '}
                        for 501(c) status.
                      </Box>
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1, mt: -0.1 }}
                      />
                      <Box>
                        {' '}
                        Apply for{' '}
                        <span style={{ fontWeight: 600 }}>
                          state corporate income tax exemption
                        </span>{' '}
                        with the SC Department of Revenue (automatic with IRS
                        determination).
                      </Box>
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1, mt: -0.2 }}
                      />
                      <Box>
                        Apply for{' '}
                        <span style={{ fontWeight: 600 }}>
                          sales tax exemption
                        </span>{' '}
                        by filing Form ST-387 with the SC Department of Revenue.
                      </Box>
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      <Box>
                        File annual IRS Form 990 series depending on revenue and
                        type of organization.
                      </Box>
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing Deadlines for Non-Profit Forms
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                Adhering to filing deadlines is essential to avoid penalties and
                maintain compliance.
              </Typography>
            </Grid>
            <Grid size={12} className="responsive">
              {' '}
              <Typography variant="body1" sx={{ mb: 1 }}>
                Below are the key deadlines for non-profit filings in South
                Carolina: Secretary of State Deadline
              </Typography>
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Secretary of State Deadline
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Articles of Incorporation
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due upon establishment of the nonprofit
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Annual Report
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Required only if nonprofit is required to file IRS
                          Form 990-T or is a foreign corporation.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Public Charities Division
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Initial Charitable Registration
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be filed before soliciting contributions in South
                          Carolina. ($50 fee).
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                          }}
                        >
                          Annual Renewal
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due annually 4.5 months after fiscal year end
                          (extension possible). <br />
                          <span style={{ fontWeight: 600 }}>Fee:</span> $0–$50
                          depending on charitable registration category.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 400,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Department of Revenue
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Sales Tax Exemption Application (ST-387)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          You may file Form ST-387 any time after receiving your
                          IRS 501(c)(3) Determination Letter. However, your
                          organization will continue paying sales tax until your
                          exemption is approved.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Form 990 Series
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due on the 15th day of the 5th month after the
                          organization&apos;s accounting period ends <br />
                          <b>Example:</b> For calendar year organizations, Form
                          990 is due by May 15
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 1023/1023-EZ
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be filed within 27 months of incorporation to
                          receive retroactive exemption to the date of
                          incorporation
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
            {/* <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    mb: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=southcarolina`}
                >
                  E-file Now with TaxZerone
                </Button>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 3,
              textAlign: 'center',
            }}
          >
            Registration & Annual Filing (Non-Profits)
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            To operate legally as a nonprofit in South Carolina, organizations
            must file
            <Hidden smDown>
              <br />
            </Hidden>{' '}
            Articles of Incorporation with the Secretary of State and pay the
            $25 filing fee.
          </Typography>

          <Grid
            container
            spacing={2}
            sx={{ mt: 4, mb: 4, px: { md: 11, sm: 2, xs: 0 } }}
          >
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Initial Registration
                  </Typography>
                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -2, '& li': { mb: 1.5 } }}
                  >
                    <li>
                      File Articles of Incorporation with the SC Secretary of
                      State.
                    </li>
                    <li>Obtain EIN from IRS.</li>
                    <li>
                      Apply for charitable registration before soliciting
                      contributions.
                    </li>
                    <li>
                      Recruit a Board of Directors (at least three directors
                      recommended).
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Annual Filing Requirements
                  </Typography>

                  <Box
                    component="ul"
                    sx={{ mb: 0, ml: -2, '& li': { mb: 1.5 } }}
                  >
                    <li>Renew charitable registration annually.</li>

                    <li>File IRS Form 990 series annually.</li>

                    <li>File SC Annual Report if applicable.</li>
                    <li>
                      Maintain proper corporate records (minutes, bylaws,
                      financials).
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Smart Compliance Tools for Nonprofits
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          TaxZerone provides accurate and secure tax filing support for
          organizations.
        </Typography>
        {/* <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=southcarolina`}
          >
            E-File Now!
          </Button>
        </Box> */}
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Are all nonprofits exempt from sales tax?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      No. Only nonprofits granted exemption by the{' '}
                      <span style={{ fontWeight: 600 }}>
                        SC Department of Revenue
                      </span>{' '}
                      are exempt.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. How do I obtain tax-exempt status for my South Carolina
                  nonprofit? ?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      Apply to the IRS for 501(c) status. Once granted, you may
                      apply for state tax exemptions.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. When is the annual charitable registration renewal due?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1, mb: 0 }}>
                      Annually, 4.5 months after the close of your fiscal year.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. How do I file Form ST-387 in South Carolina?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1">
                      {' '}
                      To apply for a Sales and Use Tax Exemption in South
                      Carolina, follow these steps:
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        Download the form: ST-387 Application for Sales and Use
                        Tax Exemption (PDF){' '}
                      </li>
                      <li>
                        Complete the application with your nonprofit’s
                        information.{' '}
                      </li>
                      <li>Attach the required documents: </li>
                      <ul>
                        <li>
                          IRS Determination Letter (501(c) status approval){' '}
                        </li>
                        <li>
                          Articles of Incorporation (filed with SC Secretary of
                          State){' '}
                        </li>
                        <li>Bylaws (if requested) </li>
                        <li>Any financial documentation SCDOR requests </li>
                      </ul>
                      <li>Mail the completed form and attachments to: </li>
                      <ul>
                        <li>
                          South Carolina Department of Revenue
                          <br />
                          Exempt Organizations Section
                          <br />
                          Columbia, SC 29214-0140
                        </li>
                      </ul>
                      <li>
                        Processing Time: Typically, 4–6 weeks.
                        <br />
                        Fee: No fee to file Form ST-387. <br />
                        Result: If approved, SCDOR will send you a Sales and Use
                        Tax Exemption Certificate.
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#014361',
                        fontSize: 16,
                      }}
                    >
                      Sources and References
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <Typography component="div" variant="body2" sx={{ mt: 1 }}>
                      This resource guide is compiled from authoritative
                      sources, including:
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li>
                        <Link
                          href="https://sos.sc.gov/online-filings/business-entities"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          South Carolina Secretary of State – Business Entities
                        </Link>
                      </li>

                      <li>
                        <Link
                          href="https://dor.sc.gov/forms-site/Forms/ST387.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          South Carolina Form ST-387 – Sales Tax Exemption
                        </Link>{' '}
                      </li>
                      <li>
                        <Link
                          href="https://www.irs.gov/charities-non-profits"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          IRS – Charities and Nonprofits
                        </Link>{' '}
                      </li>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default ExemptSouthCarolina;
